import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <section className="py-24 bg-cream" data-id="element-139">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 sm:p-12 border border-neutral-200 text-center shadow-md relative overflow-hidden" data-id="element-141">
          <ShieldCheck className="w-20 h-20 text-brand-600 mx-auto mb-8" data-id="element-142" />

          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-8" data-id="element-143">
            GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <div className="space-y-6 text-lg text-neutral-700" data-id="element-144">
            <p data-id="element-145">
              Si en 7 días sentís que CAJA DE COBRO no valió lo que pagaste, te
              devolvemos el 100% del dinero.
            </p>
            <p className="font-bold text-neutral-900" data-id="element-146">
              Sin formularios. Sin excusas. Sin drama.
            </p>
            <p data-id="element-147">Solo escribinos y listo.</p>

            <div className="my-10 h-px w-24 bg-neutral-200 mx-auto" data-id="element-148" />

            <h3 className="text-xl font-bold text-neutral-900 mb-4" data-id="element-149">
              ¿Por qué damos esta garantía?
            </h3>
            <p data-id="element-150">
              Porque sabemos que si aplicás aunque sea el 20% de lo que está
              acá, vas a notar la diferencia antes de que pasen los 7 días.
            </p>

            <div className="bg-cream p-6 rounded-xl border border-neutral-200 mt-8" data-id="element-151">
              <p className="mb-2 text-neutral-700" data-id="element-152">
                El riesgo real no es invertir $19.990 en este sistema.
              </p>
              <p className="text-brand-700 font-bold text-xl m-0" data-id="element-153">
                El riesgo real es seguir otros 30 días más sin él.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};